// extracted by mini-css-extract-plugin
module.exports = {"main":"Main_main__3de2d","links":"Main_links__1QLie","titles":"Main_titles__2LW65"};